export default {
    login(state, response){

      const {user, token, role} = response;
      state.isAuth = true;

      state.token = token;
      state.user.userId = user;

      if(role === 'Admin') {
        state.user.isAdmin = true
      }

    },
    authorize(state, authData){
      const {token, role, id} = authData
      state.isAuth = true;
      state.token = token;
      state.user.userId = id;

      if (role === 'Admin') {
        state.user.isAdmin = true
      }
    },
    loadPosts(state, response){
      state.page++;
      state.posts = [...state.posts, ...response];
    },
    getYears(state, response) {
      state.years = response.reverse();
    },
    savePost(state, response){
      // Handle both single post and array of posts (for mixed media uploads)
      if (Array.isArray(response)) {
        response.forEach(post => state.posts.unshift(post));
      } else {
        state.posts.unshift(response);
      }
    },
    deletePost(state, postId){
      let newPosts = state.posts.filter((post) => {
        return post._id !== postId;
      })

      state.posts = newPosts;
    },
    logout(state){
      state.isAuth = false;
      state.token = '';
      state.user.userId = '',
      state.user.isAdmin = false,
      state.posts = [];
      state.page = 0;
      state.loading = true;
      state.noPosts = false;
    },
    message(state, text){
      state.info = text;
    },
    setTag(state, tag){
      state.tag = tag
    },
    resetPosts(state){
      state.page = 0;
      state.posts = [];
    },
    noPosts(state, status){
      state.noPosts = status;
    },
    resetPage(state){
      state.page = 0;
    },
    loading(state, value){
      state.loading = value;
    },
    subPage(state, payload){
      state.isSubPage = payload;
    },
    isYearPage(state, payload){
      state.isYearPage = payload;
    },
    setYear(state, year){
      state.year = year;
    },
    saving(state,payload){
      state.saving = payload;
    },
    getImageModalSrc(state, payload){
      const postNum = payload[0] - 1;
      const imageNum = payload[1] - 1;

      state.imageModalSrc = state.posts[postNum].path[0][imageNum];
    },
    closeImageModal(state){
      state.imageModalSrc = '';
    },
    resetYear(state){
      state.year = '';
    },
    pageType(state, payload){
      state.pageType = payload;
    },
    setMediaType(state, payload){
      state.mediaType = payload;
    }
  }